"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dkZones = void 0;
var dkZones = exports.dkZones = [{
  id: 'COPENHAGUE',
  name: 'Copenhague',
  country: 'DK',
  cornerNW: {
    latitude: 55.7311,
    longitude: 12.4534
  },
  cornerSE: {
    latitude: 55.6145,
    longitude: 12.6401
  },
  subZones: [{
    name: 'København Indre By',
    zipcodes: {
      1050: {
        label: '1050'
      }
    }
  }, {
    name: 'København Christianshavn',
    zipcodes: {
      1060: {
        label: '1060'
      }
    }
  }, {
    name: 'København Østerbro',
    zipcodes: {
      2100: {
        label: '2100'
      }
    }
  }, {
    name: 'København Nørrebro',
    zipcodes: {
      2200: {
        label: '2200'
      }
    }
  }, {
    name: 'København Amager',
    zipcodes: {
      2300: {
        label: '2300'
      }
    }
  }]
}];